import { Breadcrumb, Card, Col, Collapse, Icon, Popconfirm, Row, Spin, Tabs, Tooltip } from 'antd'
import AccountBalanceLines from '../../../../components/Sales/Client/Contract/ViewContract/AccountBalanceLines/AccountBalanceLines'
import DocumentsCont from '../../../../components/Common/Documents/DocumentsCont'
import Communication from '../../../../components/Finance/Lender/ContractForm/Communication'
import KeyTerms from '../../../../components/Finance/Lender/ContractForm/KeyTerms'
import Overview from '../../../../components/Finance/Lender/ContractForm/Overview'
import BankDetails from '../../../../components/Finance/Lender/ViewContract/BankDetails'
import PaymentPlanCont from '../../../../components/Purchasing/Order/PaymentsPlan/PaymentPlanCont'
import Status from '../../../../elements/Status'
import { strVal } from '../../../../modules/Utils'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'

import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

const { Panel } = Collapse

function ViewContract(props) {
  const { contract, member, key, fetching, actions, lender, handleActions, contractKey, remove, fetch } = props


  const Operations = ({ contract, ...rest }) => {
    const ops = actions.map((a) => (
      <span>
        <Popconfirm
          placement="left"
          title={`Are you sure to ${a.value}?`}
          onConfirm={() =>
            a.key === 'update'
              ? props.history.replace({
                  pathname: `/finance/lenders/${member._key}/contracts/${contractKey}/update`,
                })
              : a.key === 'remove'
              ? remove()
              : handleActions(a.key)
          }
          okText="Yes"
          cancelText="No">
          <a>{a.value}</a>
        </Popconfirm>
      </span>
    ))
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <Fragment>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Finance</Breadcrumb.Item>
            <Breadcrumb.Item href="#/finance/lenders/list">Finance Partner List</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/finance/lenders/${member._key}/#contracts`}>{member.fn}</Breadcrumb.Item>
            <Breadcrumb.Item>{contract.code}</Breadcrumb.Item>
          </Breadcrumb>

          <h3>
            <h2 className={'icon-text-header'}>
              <Icon
                type="barcode"
                style={{
                  marginRight: '5px',
                  color: '#08c',
                }}
              />
              <Tooltip title="Contract  Code">{strVal(contract, 'code')}</Tooltip>
            </h2>
            <Status value={strVal(contract, 'status')} />
            <Row style={{ marginTop: 10 }}>
              <Col span={6}>Service State:</Col>
              {/*<Col span={14}>*/}
              {/*<StateSelect*/}
              {/*  value={get(contract, 'state')}*/}
              {/*  onChange={this.updateContractState}*/}
              {/*  disabled={updatingState}*/}
              {/*/>*/}
              {/*</Col>*/}
              {/*<Col span={1}>*/}
              {/*  <Spin style={{ marginLeft: 10 }} spinning={updatingState} />*/}
              {/*</Col>*/}
            </Row>
            <Operations style={{ marginTop: '10px' }} contract={contract} status={strVal(contract, 'status')} />
          </h3>
          <p>{member.fn} Finance Contract Details</p>
        </Row>
        <RefreshButton onClick={fetch}/>
      </Card>

      <Row style={{ paddingTop: '10px' }}>
        <Card loading={fetching} style={{ minHeight: '542px' }}>
          <Row style={{ paddingTop: '10px' }}>
            <Tabs defaultActiveKey="dashboard">
              <Tabs.TabPane
                tab={
                  <span>
                    <Icon type="info-circle" />
                    Details
                  </span>
                }
                key="dashboard">
                <Collapse bordered={false} defaultActiveKey={['1']}>
                  <Panel header={<h3>Account Overview</h3>} key="1">
                    <Overview contract={contract} />
                  </Panel>
                  <Panel header={<h3>Key Terms</h3>} key="2">
                    <KeyTerms contract={contract} />
                  </Panel>
                  <Panel header={<h3>Banking / Payment Details</h3>} key="3">
                    {/*<BankDetails lender={lender} member={member} contract={contract} />*/}
                    <BankDetails contract={contract} />
                  </Panel>
                  <Panel header={<h3>Communication</h3>} key="4">
                    <Communication supplier={lender} contract={contract} member={member} />
                  </Panel>
                </Collapse>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <span>
                    <Icon type="credit-card" />
                    Balance Lines
                  </span>
                }
                key="#AccountBalanceLines">
                <AccountBalanceLines contract={contract} />
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={
                  <span>
                    <Icon type="ordered-list" /> Payment Plan
                  </span>
                }
                key="payment">
                <PaymentPlanCont owner={contract} />
              </Tabs.TabPane>

              <Tabs.TabPane
                tab={
                  <span>
                    <Icon type="folder-open" />
                    Documents
                  </span>
                }
                key="docs">
                <DocumentsCont owner={contract} />
              </Tabs.TabPane>
            </Tabs>
          </Row>
        </Card>
      </Row>
    </Fragment>
  )
}

export default withRouter(ViewContract)
